module.exports = __webpack_public_path__ + "static/media/fix-help.91b14e9d.jpg";